import { render, staticRenderFns } from "./SumarioDeTeclasDeAtalho.vue?vue&type=template&id=07cd0aee&scoped=true&"
import script from "./SumarioDeTeclasDeAtalho.vue?vue&type=script&lang=ts&"
export * from "./SumarioDeTeclasDeAtalho.vue?vue&type=script&lang=ts&"
import style0 from "./SumarioDeTeclasDeAtalho.vue?vue&type=style&index=0&id=07cd0aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cd0aee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VSubheader})
